import { Div, Flex } from '@fastnorth/kraken/components/layout';
import { Text } from '@fastnorth/kraken/components/typography';
import { type FinisherCertificate } from '@fastnorth/timer-api';
import { type ReactElement } from 'react';
import { useApp } from '../../../../../../../../../../hooks/AppProvider.tsx';
import normalizeImageUrls from '../../../../../../../../../../utils/normalizeImageUrls.ts';
import AdvancedFinisherCertificate from '../../AdvancedFinisherCertificate.tsx';
import DefaultFinisherCertificate from '../../DefaultFinisherCertificate.tsx';

export type LegacyCertificateContentProps = {
  certificate: FinisherCertificate;
  substitutedContent: string;
  testId?: string;
};

const LegacyCertificateContent = ({
  certificate,
  substitutedContent,
  testId,
}: LegacyCertificateContentProps): ReactElement => {
  const [{ event }] = useApp();
  const {
    isAdvancedCustomizationEnabled,
    backgroundImageUrl,
    backgroundImageStyle,
    useBackgroundImage,
    bodyText,
    bodyBackground,
    headerBackground,
    headerText,
    isEventNameVisible,
    isEventDateVisible,
  } = certificate;
  const hideHeader = !isEventDateVisible && !isEventNameVisible;

  return (
    <Flex
      className={
        'flex-col border-black border-2 overflow-hidden w-[950px] min-h-[735px] bg-cover bg-center'
      }
      data-testid={testId}
      style={{
        letterSpacing: '1px',
        backgroundImage:
          useBackgroundImage && backgroundImageUrl
            ? `url("${normalizeImageUrls(backgroundImageUrl)}")`
            : 'unset',
        color: bodyText,
        backgroundRepeat: backgroundImageStyle === 'repeat' ? 'repeat' : 'no-repeat',
        backgroundSize: backgroundImageStyle === 'repeat' ? 'unset' : 'cover',
        backgroundColor: bodyBackground,
      }}>
      {!hideHeader && (
        <Flex
          className={'justify-between w-full'}
          style={{ background: headerBackground, color: headerText }}>
          {isEventNameVisible ? (
            <Text spacing={'4 0 0 4'} fontWeight={'bold'} size={'xl'}>
              {event?.name}
            </Text>
          ) : (
            <>&nbsp;</>
          )}
          {isEventDateVisible ? (
            <Text spacing={'4 4 4 0'} fontWeight={'bold'} size={'xl'}>
              {event?.dates?.eventDate
                ? new Date(event.dates.eventDate).toLocaleDateString()
                : null}
            </Text>
          ) : (
            <>&nbsp;</>
          )}
        </Flex>
      )}
      <Div spacing={'7 0'} className={'h-full'}>
        {isAdvancedCustomizationEnabled ? (
          <AdvancedFinisherCertificate content={substitutedContent} />
        ) : (
          <DefaultFinisherCertificate certificate={certificate} />
        )}
      </Div>
    </Flex>
  );
};

export default LegacyCertificateContent;
